/* eslint-disable */

/*
    🔥 DATOS CRUDOS DE LA EMPRESA — EN CommonJS A PROPÓSITO

    ⚠️ POR QUÉ ESTE ARCHIVO EXISTE Y NO ESTÁ TODO EN AppCompanyConfig.js

       scripts/generate-company-env.js corre en NODE, antes del build, con
       require(). Node no puede hacer require() de un archivo con export const:
       tira ERR_REQUIRE_ESM.

       Por eso los valores literales viven acá en module.exports, que lo leen
       los dos mundos:

           el script de Node   -> require()
           la app en el browser -> import, vía AppCompanyConfig.js

    ⚠️ ACÁ NO SE AGREGA NADA QUE NECESITE EL NAVEGADOR.

       Nada de process.env.PUBLIC_URL, rutas de imágenes ni lógica de tema: eso
       va en AppCompanyConfig.js, que es el que arma el objeto final.

    ⚠️ SI MOVÉS ESTE ARCHIVO, ACTUALIZÁ scripts/generate-company-env.js.
       Es el único de afuera de src/ que lo lee.
*/


// ---------------------------------------- 🔥 IDENTIDAD
const COMPANY_NAME = "Bailador";
const COMPANY_CLAIM = "Portfolio de desarrollo de software";
const COMPANY_TLD = "com";
const START_YEAR = 2016;

// Cache-busting de assets estaticos (favicon, iconos PWA).
// Si reemplazas el favicon en el futuro, cambia SOLO este valor y reinicia npm start.
const COMPANY_ASSET_VERSION = "20260906-01";

const COMPANY_DOMAIN_CUSTOM = "bailador-project.com";


// ---------------------------------------- 🔥 SEO
const COMPANY_DESCRIPTION = "Portfolio profesional de desarrollo de software, arquitectura, productos digitales, automatización y experiencias web.";
const COMPANY_KEYWORDS = "portfolio desarrollador, full stack developer, arquitectura de software, react, php, APIs, automatizacion, desarrollo web";

const COMPANY_LANG = "es";
const COMPANY_LOCALE = "es_AR";
const COMPANY_THEME_COLOR = "#616161";

const COMPANY_OG_TITLE = `${COMPANY_NAME} | Portfolio de desarrollo de software`;
const COMPANY_OG_DESCRIPTION = "Proyectos, trayectoria, artículos y experiencia técnica reunidos en un portfolio profesional.";

const COMPANY_TWITTER_TITLE = `${COMPANY_NAME} | Portfolio`;
const COMPANY_TWITTER_DESCRIPTION = "Portfolio profesional de desarrollo de software, arquitectura y productos digitales.";

const COMPANY_OG_IMAGE = "/logo512.png"; // VIVE EN PUBLIC


// ---------------------------------------- 🔥 DERIVADOS (NO SE TOCAN A MANO)
const COMPANY_SLUG = "gebailador"; // Namespace tecnico/API heredado del backend. La marca visible sigue siendo Bailador.
const COMPANY_CODE = COMPANY_SLUG.toUpperCase();
const COMPANY_DOMAIN = COMPANY_DOMAIN_CUSTOM || `${COMPANY_SLUG}.${COMPANY_TLD}`;
const COMPANY_WEBSITE = `https://${COMPANY_DOMAIN}`;
const COMPANY_TITLE_FULL = `${COMPANY_NAME} - ${COMPANY_CLAIM}`;

const CURRENT_YEAR = new Date().getFullYear();
const COMPANY_YEARS = START_YEAR >= CURRENT_YEAR ? `${CURRENT_YEAR}` : `${START_YEAR} - ${CURRENT_YEAR}`;

const COPYRIGHT = `© ${COMPANY_NAME} - ${COMPANY_YEARS}. Todos los derechos reservados.`;

const COMPANY_OG_IMAGE_URL = `${COMPANY_WEBSITE}${COMPANY_OG_IMAGE}`; // ABSOLUTA: los scrapers no resuelven rutas relativas.

const COMPANY_LOCALE_MANIFEST = COMPANY_LOCALE.replace("_", "-");


module.exports = {

    COMPANY_TLD, START_YEAR, COMPANY_ASSET_VERSION, COMPANY_NAME, COMPANY_CLAIM, COMPANY_DOMAIN_CUSTOM,

    COMPANY_SLUG, COMPANY_CODE, COMPANY_DOMAIN, COMPANY_WEBSITE, COMPANY_TITLE_FULL,

    CURRENT_YEAR, COMPANY_YEARS, COPYRIGHT,

    COMPANY_DESCRIPTION, COMPANY_KEYWORDS,
    COMPANY_LANG, COMPANY_LOCALE, COMPANY_LOCALE_MANIFEST, COMPANY_THEME_COLOR,

    COMPANY_OG_TITLE, COMPANY_OG_DESCRIPTION,
    COMPANY_TWITTER_TITLE, COMPANY_TWITTER_DESCRIPTION,
    COMPANY_OG_IMAGE, COMPANY_OG_IMAGE_URL,

};
